var _rect, _rect2, _path, _rect3, _path2, _rect4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoTasks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 70,
  x: 30,
  y: 25,
  stroke: "currentColor",
  strokeWidth: 3,
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 45,
  y: 40,
  stroke: "currentColor",
  strokeWidth: 2,
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M58 44h17"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 45,
  y: 56,
  stroke: "currentColor",
  strokeWidth: 2,
  rx: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M58 60h17"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 45,
  y: 72,
  stroke: "currentColor",
  strokeWidth: 2,
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M58 76h17"
})));
export default SvgNoTasks;